module.exports = __webpack_public_path__ + "img/SharkFlag-green@3x.b508217b.svg";